<div class ="px-3">

<div *ngIf='template; else loader'>
    <h5 class="my-2">
        {{headingText}}
    </h5>

    <mat-divider class="py-2"></mat-divider>


    <div *ngIf="pdfBlob; else pdfFailed">
        <ngx-extended-pdf-viewer [src]="pdfBlob" useBrowserLocale="true" [textLayer]="true" height="80vh" #pdfViewer>
        </ngx-extended-pdf-viewer>
    </div>
    <ng-template #pdfFailed>
        <button mat-raised-button color="primary" (click)="retryPdfConversion()">
            Ritenta conversione in PDF
        </button>
    </ng-template>
    <mat-divider class="mt-3"></mat-divider>
    <div class="py-3">
        <button mat-raised-button color="primary" (click)="download(template)">Scarica template (non PDF)</button>
    </div>


</div>
<ng-template #loader>
    <mat-spinner></mat-spinner>
</ng-template>
</div>